

















import { defineComponent, provide, onMounted, ref } from '@vue/composition-api'
import store, { key } from './store'

export default defineComponent({
  setup() {
    provide(key, store)
    const dialogPortrait = ref(false)

    const isPortrait = (): boolean => {
      if (window.innerHeight > window.innerWidth) {
        return true
      }
      return false
    }

    function setDialogPortrait() {
      dialogPortrait.value = isPortrait()
    }

    onMounted(() => {
      setDialogPortrait()
    })

    return {
      dialogPortrait,
      setDialogPortrait,
    }
  },
})
